import Select from "../inputs/Select";
import ButtonIcon from "../buttons/Button.icon";
import React from "react";

import './dropdown.multiple.scss';

function DropdownMultipleListItem({index, item, options, onChange, onRemove}) {
    const getKeys = () => {
        return options(item).map((v) => {
            return {label: v.key, value: v.key}
        });
    }
    const getValues = () => {
        const option = options(item).find((d) => d.key === item.key);
        if (!option) {
            return [];
        }
        return option.value.map((v) => {
            return {label: v, value: v}
        });
    }

    const onKeyChange = (v) => {
        item.key = v;
        onChange(index, item);
    }

    const onValueChange = (v) => {
        item.value = v;
        onChange(index, item);
    }

    return (
        <div className="itemBase">
            <Select required={false} value={item.key} onChange={onKeyChange} placeholder="--" options={getKeys()} />
            <Select required={false} value={item.value} onChange={onValueChange} placeholder="--" options={getValues()} />
            <i className="material-icons _iconClose" onClick={onRemove}>close</i>
        </div>
    );
}

function DropdownMultipleList({items, options, onChange}) {
    const _items = items? items : [];

    const getAvailableOptions = (item) => {
        const keys = _items.map((v) => v.key);
        const _options = options.filter((d) => {
            if (item && d.key === item.key) return true;
            return !keys.includes(d.key);
        });
        return JSON.parse(JSON.stringify(_options));
    }

    const add = () => {
        const _options = getAvailableOptions();
        if (_options.length !== 0) {
            _items.push({
                key: _options[0].key,
                value: null
            });
            onChange(JSON.parse(JSON.stringify(_items)));
        }
    }

    const remove = (i) => {
        return () => {
            _items.splice(i, 1);
            onChange(JSON.parse(JSON.stringify(_items)));
        }
    }

    const _onChange = (index, item) => {
        _items[index] = item;
        onChange(JSON.parse(JSON.stringify(_items)));
    }

    return (
        <div className="dropdownMultipleComponentList">
            <div className="items">
                {
                    _items.map((item, i) => (
                        <DropdownMultipleListItem key={i} index={i} item={item} options={getAvailableOptions} onChange={_onChange} onRemove={remove(i)} />
                    ))
                }
            </div>
            <div className="containerItems">
                <div className="actionButton" onClick={add}>
                    <ButtonIcon size={34}>
                        <span className="material-icons">
                            add
                            </span>
                    </ButtonIcon>
                    <p>Add parameter</p>
                </div>
            </div>
        </div>
    )
}

export default DropdownMultipleList;
